import React from "react";
import notFound from "../../assets/images/svg/notFound.svg";
import Header from "../../components/Header/Header";
import { homePageRoute } from "../../utils/constants";

const NoDataFound = () => {
  return (
    <div>
      <Header type={homePageRoute} />
      <div className="not_found_outer_main">
        <div className="not_found_inside_main">
          <img className="notFound" src={notFound} alt="No Data Found" />
          <h2 className="oops">Oops!</h2>
          <h3 className="nodata">No Data Found</h3>
        </div>
      </div>
    </div>
  );
};

export default NoDataFound;
